<form class="numero-dialog-form"
      [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSalvar()">

  <div class="dialog-conteudo">
    <div class="alerta-erro" role="alert" *ngIf="mensagemErro">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{mensagemErro}}</span>
    </div>

    <section class="identificacao" aria-label="Identificação do número">
      <div class="campo-telefone">
        <label for="whatsapp">Número WhatsApp</label>

        <div class="telefone-input">
          <i class="fab fa-whatsapp" aria-hidden="true"></i>
          <input
            type="tel"
            id="whatsapp"
            name="whatsapp"
            [(ngModel)]="telefoneFormatado"
            placeholder="(11) 99999-9999"
            autocomplete="off"
            appAutoFocus [autoFocus]="true"
            required
            campoTelefone
            #whatsapp="ngModel"
            (blur)="onTelefoneBlur()"
            (input)="onTelefoneInput($event)">
        </div>

        <div class="campo-erros" *ngIf="whatsapp.invalid && (whatsapp.dirty || frm.submitted)">
          <span *ngIf="whatsapp.errors?.required">
            <i class="fas fa-exclamation-circle"></i>
            Informe o número WhatsApp
          </span>
          <span *ngIf="whatsapp.errors?.campoTelefone">
            <i class="fas fa-exclamation-circle"></i>
            Use um número brasileiro com DDD.
          </span>
        </div>

        <small>Celular com 11 dígitos ou telefone fixo com 10.</small>
      </div>

      <label for="ocultar" class="visibilidade">
        <input name="ocultar" id="ocultar" class="checkbox-modern" type="checkbox"
               kendoCheckBox [(ngModel)]="numeroWhatsapp.ocultar"/>
        <span>
          <strong>Ocultar no cardápio</strong>
          <small>Clientes não verão este número.</small>
        </span>
      </label>
    </section>

    <section class="protecao-envios" [class.protecao-pausada]="numeroWhatsapp.pausado">
      <header class="protecao-cabecalho">
        <div class="protecao-identidade">
          <span class="protecao-icone"><i class="fas fa-shield-alt"></i></span>
          <div>
            <h6>Campanhas e fidelidade</h6>
            <p>
              Define o volume e o horário de campanhas e mensagens automáticas de fidelidade.
              <strong>Status do pedido e avaliações de pedidos têm ritmos próprios e ficam fora deste limite.</strong>
            </p>
          </div>
        </div>

        <span class="protecao-status">
          <span></span>
          {{numeroWhatsapp.pausado ? 'Marketing pausado' : 'Controle ativo'}}
        </span>
      </header>

      <div class="politica-carregando" *ngIf="carregandoPolitica">
        <span class="k-i-loading"></span>
        Carregando regras deste número...
      </div>

      <div *ngIf="politicaCarregada" class="protecao-conteudo">
        <div class="configuracao-envios">
          <section class="configuracao-secao limite-diario"
                   [class.limite-diario-risco]="limiteElevado">
            <header class="secao-cabecalho">
              <div class="secao-titulo">
                <span class="secao-icone" aria-hidden="true">
                  <i class="fas fa-sliders-h"></i>
                </span>
                <div>
                  <h6>Limite de mensagens por dia</h6>
                </div>
              </div>

              <div class="limite-valor" *ngIf="!numeroWhatsapp.pausado">
                <input type="number"
                       name="limiteDiario"
                       [(ngModel)]="numeroWhatsapp.limiteDiario"
                       min="10"
                       [max]="limiteMaximoSlider"
                       step="5"
                       required
                       aria-label="Máximo de mensagens de marketing por dia">
                <span>mensagens/dia</span>
              </div>

              <div class="limite-valor limite-valor-pausado" *ngIf="numeroWhatsapp.pausado">
                <strong>Pausado</strong>
              </div>
            </header>

            <p class="limite-validacao" role="alert" *ngIf="limiteDiarioAbaixoDoMinimo">
              <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
              O limite mínimo é 10 mensagens por dia.
            </p>

            <div class="limite-controle">
              <div class="volume-slider-area">
                <input type="range"
                       class="volume-slider"
                       [class.volume-slider-risco]="limiteElevado"
                       min="0"
                       [max]="limiteMaximoSlider"
                       step="5"
                       [value]="limiteSlider"
                       [style.background]="fundoDoSliderLimite"
                       (input)="atualizeLimitePeloSlider($event)"
                       aria-label="Ajustar o máximo de mensagens de marketing por dia">

                <div class="volume-marcos" aria-label="Atalhos do limite diário">
                  <button type="button" class="volume-marco"
                          [class.volume-marco-ativo]="limiteSlider === 0"
                          (click)="definaLimiteDiario(0)"
                          aria-label="Pausar os envios proativos">
                    <span></span>
                    <strong>0</strong>
                  </button>
                  <button type="button" class="volume-marco"
                          [class.volume-marco-ativo]="limiteSlider === 25"
                          (click)="definaLimiteDiario(25)"
                          aria-label="Definir 25 mensagens por dia">
                    <span></span>
                    <strong>25</strong>
                  </button>
                  <button type="button" class="volume-marco"
                          [class.volume-marco-ativo]="limiteSlider === 50"
                          (click)="definaLimiteDiario(50)"
                          aria-label="Definir 50 mensagens por dia">
                    <span></span>
                    <strong>50</strong>
                  </button>
                  <button type="button" class="volume-marco"
                          [class.volume-marco-ativo]="limiteSlider === 75"
                          (click)="definaLimiteDiario(75)"
                          aria-label="Definir 75 mensagens por dia">
                    <span></span>
                    <strong>75</strong>
                  </button>
                  <button type="button" class="volume-marco"
                          [class.volume-marco-ativo]="limiteSlider === 100"
                          (click)="definaLimiteDiario(100)"
                          aria-label="Definir o limite recomendado de 100 mensagens por dia">
                    <span></span>
                    <strong>100</strong>
                    <small>Recomendado</small>
                  </button>
                  <button type="button" class="volume-marco volume-marco-risco"
                          [class.volume-marco-ativo]="limiteSlider === 125"
                          (click)="definaLimiteDiario(125)"
                          aria-label="Definir 125 mensagens por dia, acima do recomendado">
                    <span></span>
                    <strong>125</strong>
                  </button>
                  <button type="button" class="volume-marco volume-marco-risco"
                          [class.volume-marco-ativo]="limiteSlider === 150"
                          (click)="definaLimiteDiario(150)"
                          aria-label="Definir 150 mensagens por dia, acima do recomendado">
                    <span></span>
                    <strong>150</strong>
                    <small>Máximo</small>
                  </button>
                </div>
              </div>

              <div class="alerta-limite-elevado" role="alert" *ngIf="limiteElevado">
                <i class="fas fa-exclamation-triangle"></i>
                <span>
                  <strong>Maior risco de bloqueio.</strong>
                  Acima de 100 mensagens por dia pode aumentar o risco de banimento pelo WhatsApp.
                  O espaçamento reduz envios em sequência, mas não elimina esse risco.
                </span>
              </div>

              <p class="limite-ajuda" *ngIf="!numeroWhatsapp.pausado">
                <i class="fas fa-check-circle" aria-hidden="true"></i>
                <span>
                  O sistema usará <strong>até {{numeroWhatsapp.limiteDiario}} envios de marketing por dia</strong>.
                  Se houver menos pendentes, enviará menos.
                </span>
              </p>
              <p class="limite-ajuda limite-ajuda-pausada" *ngIf="numeroWhatsapp.pausado">
                <i class="fas fa-pause-circle" aria-hidden="true"></i>
                <span>
                  Campanhas e mensagens de fidelidade ficarão pendentes. Status do pedido e avaliações de pedidos continuarão normalmente.
                </span>
              </p>
            </div>
          </section>
        </div>

        <aside class="painel-lateral-configuracao">
          <div class="uso-hoje" *ngIf="numeroWhatsapp.id && !numeroWhatsapp.pausado">
            <div>
              <span>Limite de marketing usado hoje</span>
              <strong>{{usadoHojeExibicao}} de {{numeroWhatsapp.limiteDiario}}</strong>
            </div>
            <div class="uso-trilho" aria-hidden="true">
              <span [style.width.%]="percentualUsadoHoje"></span>
            </div>
            <small>{{restanteHojeCalculado}} envios de marketing disponíveis</small>
          </div>

          <div class="incertas-hoje" *ngIf="numeroWhatsapp.incertasHoje > 0">
            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
            <span>
              <strong>{{numeroWhatsapp.incertasHoje}}</strong>
              {{numeroWhatsapp.incertasHoje === 1 ? 'envio precisa' : 'envios precisam'}} de conferência hoje.
            </span>
          </div>

          <section class="horario-previsao" aria-labelledby="horario-previsao-titulo">
            <header class="horario-previsao-cabecalho">
              <h6 id="horario-previsao-titulo">
                <i class="fas fa-clock" aria-hidden="true"></i>
                Horário de campanhas e fidelidade
              </h6>
              <span>{{duracaoDaJanelaHoras}}h por dia</span>
            </header>

            <div class="horario-linha">
              <div class="hora-campo">
                <label for="janelaInicioHora">Início</label>
                <div>
                  <input type="number" id="janelaInicioHora" name="janelaInicioHora"
                         [(ngModel)]="numeroWhatsapp.janelaInicioHora"
                         min="0" max="23" required
                         #janelaInicioHora="ngModel">
                  <span>h</span>
                </div>
                <small *ngIf="janelaInicioHora.invalid && janelaInicioHora.touched">Use 0 a 23.</small>
              </div>

              <span class="horario-separador" aria-hidden="true">
                <i class="fas fa-arrow-right"></i>
              </span>

              <div class="hora-campo">
                <label for="janelaFimHora">Fim</label>
                <div>
                  <input type="number" id="janelaFimHora" name="janelaFimHora"
                         [(ngModel)]="numeroWhatsapp.janelaFimHora"
                         min="0" max="23" required
                         #janelaFimHora="ngModel">
                  <span>h</span>
                </div>
                <small *ngIf="janelaFimHora.invalid && janelaFimHora.touched">Use 0 a 23.</small>
              </div>
            </div>

            <p class="horario-ajuda">
              Das <strong>{{horaInicioFormatada}}h às {{horaFimFormatada}}h</strong>.
              Horários iguais liberam os envios durante 24 horas.
            </p>
          </section>

        </aside>

        <section class="distribuicao-informativa" aria-labelledby="distribuicao-titulo">
          <h6 id="distribuicao-titulo">
            <i class="fas fa-stream" aria-hidden="true"></i>
            Ritmo calculado automaticamente
          </h6>

          <div class="ritmos-lista">
            <section class="ritmo-grupo ritmo-grupo-ilimitado" aria-label="Status do pedido e avaliações de pedidos sem limite diário">
              <header class="ritmo-grupo-cabecalho">
                <span>Pedidos e avaliações</span>
                <strong>Ilimitado</strong>
              </header>

              <dl class="ritmo-grupo-cards">
                <div>
                  <dt><span class="ritmo-nome"><i class="fas fa-receipt" aria-hidden="true"></i> Status do pedido</span></dt>
                  <dd>Até 1 mensagem a cada {{formateDuracao(numeroWhatsapp.intervaloStatusPedidoSegundos || 30)}}</dd>
                  <small>Fora do limite diário e do horário de marketing</small>
                </div>
                <div>
                  <dt><span class="ritmo-nome"><i class="fas fa-star" aria-hidden="true"></i> Avaliações de pedidos</span></dt>
                  <dd>Até 1 mensagem a cada {{formateDuracao(numeroWhatsapp.intervaloAvaliacaoSegundos || 300)}}</dd>
                  <small>A partir de 30min após o pedido; fora do limite diário</small>
                </div>
              </dl>
            </section>

            <section class="ritmo-grupo ritmo-grupo-marketing" aria-label="Campanhas e fidelidade com limite diário compartilhado">
              <header class="ritmo-grupo-cabecalho">
                <span>Campanhas de marketing + fidelidade</span>
                <strong><span class="ritmo-limite-valor">{{numeroWhatsapp.limiteDiario}}</span> msg por dia</strong>
              </header>

              <dl class="ritmo-grupo-cards">
                <div>
                  <dt><span class="ritmo-nome"><i class="fas fa-bullhorn" aria-hidden="true"></i> Campanhas de marketing</span></dt>
                  <dd>Até 1 mensagem a cada {{formateDuracao(intervaloCalculadoSegundos)}}</dd>
                </div>
                <div>
                  <dt><span class="ritmo-nome"><i class="fas fa-robot" aria-hidden="true"></i> Mensagens de fidelidade</span></dt>
                  <dd>Até 1 mensagem a cada {{formateDuracao(intervaloAutomacaoCalculadoSegundos)}}</dd>
                </div>
              </dl>
            </section>
          </div>

          <div class="distribuicao-notas">
            <p class="continuidade">
              <i class="fas fa-shield-alt" aria-hidden="true"></i>
              Entre mensagens automáticas, o sistema mantém no mínimo
              {{formateDuracao(numeroWhatsapp.intervaloGlobalAutomaticoSegundos || 30)}} de intervalo.
            </p>
            <p class="continuidade">
              <i class="fas fa-calendar-alt" aria-hidden="true"></i>
              Campanhas e mensagens de fidelidade que não saírem hoje continuam automaticamente no próximo dia.
            </p>

            <p class="prioridade">
              <i class="fas fa-sort-amount-down" aria-hidden="true"></i>
              Status do pedido e avaliações de pedidos têm prioridade. Mensagens de fidelidade e campanhas usam os intervalos disponíveis.
            </p>
            <p class="prioridade">
              <i class="fas fa-calculator" aria-hidden="true"></i>
              O ritmo muda com o limite, o horário e o tamanho de cada campanha. Listas menores podem sair mais devagar.
            </p>
          </div>
        </section>
      </div>
    </section>
  </div>

  <footer class="modal-footer-modern">
    <div class="footer-acoes">
      <button type="button" (click)="fechar()" class="btn-modern btn-secondary">
        Cancelar
      </button>
      <button type="submit" class="btn-modern btn-primary"
              [disabled]="enviando || frm.invalid || !politicaCarregada">
        <i class="fas fa-spinner fa-spin" *ngIf="enviando"></i>
        <i class="fas fa-save" *ngIf="!enviando"></i>
        <span *ngIf="!enviando">Salvar alterações</span>
        <span *ngIf="enviando">Salvando...</span>
      </button>
    </div>
  </footer>
</form>
